export function profileHref(user: {
  role: string | null
  profile_slug: string | null
}): string {
  if (!user.profile_slug) return "/perfil/editar"
  if (user.role === "scout") return `/scouts/${user.profile_slug}`
  if (user.role === "club") return `/clubes/${user.profile_slug}`
  return `/jugadores/${user.profile_slug}`
}
